import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  background-color: ",
        ";\n  color: ",
        ";\n  border-radius: 16px;\n  padding: 0 8px;\n  font-size: 10px; // Adjusted for bottom nav's smaller text size\n  font-weight: 700;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 22px;  // To match the height of the icon\n  overflow: visible;\n  position: relative;\n  z-index: 2;\n  margin-left: -8px;  // Let the badge overflow a bit on the left\n  margin-right: -8px;  // Let the badge overflow a bit on the right\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        '\n &::before {\n  content: "";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  width: calc(100% + 2px);\n  margin-left: -2px;\n  background: ',
        ";\n}"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from "react";
import { MenuContext } from "../../widgets/Menu/context";
import { Flex } from "../Box";
import AnimatedIconComponent from "../Svg/AnimatedIconComponent";
import { StyledBottomNavItem, StyledBottomNavText } from "./styles";
import styled, { useTheme } from "styled-components";
var ComingSoonBadge = styled.div.withConfig({
    componentId: "sc-8baee150-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
}, function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var ActiveFlex = styled(Flex).withConfig({
    componentId: "sc-8baee150-1"
})(_templateObject1(), function(param) {
    var theme = param.theme, isActive = param.isActive;
    return isActive ? theme.colors.alienPurple : theme.colors.cardBorder;
});
var BottomNavItem = function(_param) {
    var label = _param.label, icon = _param.icon, fillIcon = _param.fillIcon, href = _param.href, _showItemsOnMobile = _param.showItemsOnMobile, showItemsOnMobile = _showItemsOnMobile === void 0 ? false : _showItemsOnMobile, _isActive = _param.isActive, isActive = _isActive === void 0 ? false : _isActive, _disabled = _param.disabled, disabled = _disabled === void 0 ? false : _disabled, _isComingSoon = _param.isComingSoon, isComingSoon = _isComingSoon === void 0 ? false : _isComingSoon, props = _object_without_properties(_param, [
        "label",
        "icon",
        "fillIcon",
        "href",
        "showItemsOnMobile",
        "isActive",
        "disabled",
        "isComingSoon"
    ]);
    var linkComponent = useContext(MenuContext).linkComponent;
    var theme = useTheme();
    var bottomNavItemContent = /*#__PURE__*/ _jsxs(ActiveFlex, {
        style: {
            boxShadow: "\n          1px 0 0 0 ".concat(theme.colors.cardBorder, ", \n          0 2px 0 0 ").concat(theme.colors.cardBorder, "\n        "),
            overflowX: "hidden"
        },
        isActive: isActive,
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        position: "relative",
        children: [
            isComingSoon ? /*#__PURE__*/ _jsx(ComingSoonBadge, {
                children: "Coming Soon"
            }) : icon && href === "/info" && /*#__PURE__*/ _jsx(AnimatedIconComponent, {
                icon: icon,
                fillIcon: fillIcon,
                height: "22px",
                width: "21px",
                color: isActive ? "secondary" : "textSubtle",
                isActive: isActive
            }),
            /*#__PURE__*/ _jsx(StyledBottomNavText, {
                color: isActive ? "text" : "textSubtle",
                fontWeight: 700,
                fontSize: "14px",
                fontFamily: "Syncopate, sans-serif",
                textTransform: "uppercase",
                children: label
            })
        ]
    });
    return showItemsOnMobile ? /*#__PURE__*/ _jsx(StyledBottomNavItem, _object_spread_props(_object_spread({
        style: {
            opacity: disabled ? 0.5 : 1,
            padding: "0px"
        },
        type: "button"
    }, props), {
        children: bottomNavItemContent
    })) : /*#__PURE__*/ _jsx(StyledBottomNavItem, _object_spread_props(_object_spread({
        style: {
            opacity: disabled ? 0.5 : 1
        },
        as: linkComponent,
        href: href
    }, props), {
        children: bottomNavItemContent
    }));
};
export default BottomNavItem;
